<template>
  <v-list-tile class="list-tile">
    <v-list-tile-content class="list-content white--text">{{ title }}</v-list-tile-content>
    <slot></slot>
  </v-list-tile>
</template>

<script>
export default {
  props: {
    title: String
  }
}
</script>

<style scoped>
.list-tile {
  margin: 1.23em 0 0.28em 0;
  background-color: #0BBAD9;
}
.list-content {
  padding: 0 0 0 0.5em;
}
</style>
